import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=368c6e3f&scoped=true"
import script from "./BackIcon.vue?vue&type=script&lang=js"
export * from "./BackIcon.vue?vue&type=script&lang=js"
import style0 from "./BackIcon.vue?vue&type=style&index=0&id=368c6e3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c6e3f",
  null
  
)

export default component.exports